import { API_URL } from "../lib/constants";
import fetchWithRequestId from "./common";

export const getDiscussionsByPoolId = (accessToken, poolId) => {
  return fetchWithRequestId(`${API_URL}/discussions?poolId=${poolId}`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};
